/**
 * Parent Empty State
 *
 * Shared empty state component for parent selection.
 * Shows "no results" or "no available parents" depending on context.
 */

import { Text, VStack } from '@chakra-ui/react';
import { Command } from 'cmdk';
import { gradientVariantForGlyph } from '../../../theme/iconGradient';
import { MaterialIcon } from '../../ui/MaterialIcon';

interface ParentEmptyStateProps {
  query: string;
  isFetching: boolean;
  hasOptions: boolean;
}

export function ParentEmptyState({ query, isFetching, hasOptions }: ParentEmptyStateProps) {
  if (isFetching || hasOptions) return null;

  if (query.trim().length > 0) {
    return (
      <Command.Empty>
        <MaterialIcon
          name="search_off"
          boxSize={10}
          gradient={gradientVariantForGlyph('search_off')}
        />
        <Text fontSize="sm" color="text.muted">
          No results found
        </Text>
      </Command.Empty>
    );
  }

  return (
    <VStack py={8} spacing={3}>
      <MaterialIcon name="folder_off" boxSize={10} gradient="warm" />
      <Text fontSize="sm" color="text.muted">
        No available parents
      </Text>
    </VStack>
  );
}
